/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShippingOrderSubstitutionDetailResponse {
  baldConflict?: boolean;
  brandEquity?: number;
  brandEquityNew?: number;
  category?: string;
  categoryNew?: string;
  costPrice?: number;
  costPriceNew?: number;
  imageUrl?: string;
  imageUrlNew?: string;
  invoicePrice?: number;
  invoicePriceNew?: number;
  productVariantId?: number;
  productVariantIdNew?: number;
  productVariantImage?: string;
  productVariantImageNew?: string;
  productVariantName?: string;
  productVariantNameNew?: string;
  rating?: number;
  ratingNew?: number;
  received?: boolean;
  salePrice?: number;
  salePriceNew?: number;
  weight?: number;
  weightNew?: number;
}
